export default "skymp5-front/bb616c382308b6759126ee8480600e81.png";